export const webhookListSupported = {
	types: Object.freeze({
		'rgb.on': {},
		'rgb.off': {},
		'rgbw.on': {},
		'rgbw.off': {},
		'light.on': {},
		'light.off': {},
		'cct.on': {},
		'cct.off': {},
		'switch.on': {},
		'switch.off': {},
		'input.toggle_on': {},
		'input.toggle_off': {},
		'input.button_push': {},
		'input.button_longpush': {},
		'input.button_doublepush': {},
		'input.button_triplepush': {},
		'input.touch_multi_touch': {},
		'input.touch_swipe_down': {},
		'input.touch_swipe_up': {},
		'input.analog_change': {
			attrs: [
				{ name: 'percent', type: 'number', desc: 'action_title_voltage_in_%' },
				{
					name: 'xpercent',
					type: 'number',
					desc: 'action_title_transformed_analog_value',
				},
			],
		},
		'input.analog_measurement': {
			attrs: [
				{ name: 'percent', type: 'number', desc: 'action_title_voltage_in_%' },
				{
					name: 'xpercent',
					type: 'number',
					desc: 'action_title_transformed_analog_value',
				},
			],
		},
		'temperature.change': {
			attrs: [
				{
					name: 'tC',
					type: 'number',
					desc: 'action_title_temperature_in_celsius',
				},
				{
					name: 'tF',
					type: 'number',
					desc: 'action_title_temperature_in_fahrenheit',
				},
			],
		},
		'temperature.measurement': {
			attrs: [
				{
					name: 'tC',
					type: 'number',
					desc: 'action_title_temperature_in_celsius',
				},
				{
					name: 'tF',
					type: 'number',
					desc: 'action_title_temperature_in_fahrenheit',
				},
			],
		},
		'humidity.change': {
			attrs: [{ name: 'rh', type: 'number', desc: 'action_title_humidity_in_%' }],
		},
		'humidity.measurement': {
			attrs: [{ name: 'rh', type: 'number', desc: 'action_title_humidity_in_%' }],
		},
		'voltmeter.change': {
			attrs: [
				{
					name: 'voltage',
					type: 'number',
					desc: 'action_title_voltage_in_volts',
				},
				{
					name: 'xvoltage',
					type: 'number',
					desc: 'action_title_transformed_voltage_value',
				},
			],
		},
		'voltmeter.measurement': {
			attrs: [
				{
					name: 'voltage',
					type: 'number',
					desc: 'action_title_voltage_in_volts',
				},
				{
					name: 'xvoltage',
					type: 'number',
					desc: 'action_title_transformed_voltage_value',
				},
			],
		},
		'smoke.alarm': {},
		'smoke.alarm_off': {},
		'smoke.alarm_test': {},
		'cover.stopped': {},
		'cover.open': {},
		'cover.closed': {},
		'cover.opening': {},
		'cover.closing': {},
		'illuminance.change': {
			attrs: [
				{
					name: 'illumination',
					type: 'string',
					desc: 'Illumination changed beyond the configured dark/twilight/bright thresholds',
				},
			],
		},
		'illuminance.measurement': {
			attrs: [
				{
					name: 'illumination',
					type: 'string',
					desc: 'action_title_illuminance_value_measured_regardless_of_configured_threshold',
				},
			],
		},
		'em.voltage_change': {
			attrs: [
				{
					name: 'phase',
					type: 'string',
					desc: 'action_title_phase_which_generates_the_event_one_of_a_b_c',
				},
				{
					name: 'voltage',
					type: 'number',
					desc: 'action_title_phase_voltage_in_Volts',
				},
			],
		},
		'em.current_change': {
			attrs: [
				{
					name: 'phase',
					type: 'string',
					desc: 'action_title_phase_which_generates_the_event_one_of_a_b_c_n',
				},
				{
					name: 'current',
					type: 'number',
					desc: 'action_title_phase_current_in_Amps',
				},
			],
		},
		'em.active_power_change': {
			attrs: [
				{
					name: 'phase',
					type: 'string',
					desc: 'action_title_phase_which_generates_the_event_one_of_a_b_c',
				},
				{
					name: 'act_power',
					type: 'number',
					desc: 'action_title_phase_active_power_in_Watts',
				},
			],
		},
		'em1.voltage_change': {
			attrs: [
				{
					name: 'voltage',
					type: 'number',
					desc: 'action_title_phase_voltage_in_Volts',
				},
			],
		},
		'em1.current_change': {
			attrs: [
				{
					name: 'current',
					type: 'number',
					desc: 'action_title_phase_current_in_Amps',
				},
			],
		},
		'em1.active_power_change': {
			attrs: [
				{
					name: 'act_power',
					type: 'number',
					desc: 'action_title_phase_active_power_in_Watts',
				},
			],
		},
		'pm1.voltage_change': {
			attrs: [
				{
					name: 'voltage',
					type: 'number',
					desc: 'action_title_voltage_in_Volts',
				},
			],
		},
		'pm1.current_change': {
			attrs: [
				{
					name: 'current',
					type: 'number',
					desc: 'action_title_current_in_Amps',
				},
			],
		},
		'pm1.apower_change': {
			attrs: [
				{
					name: 'apower',
					type: 'number',
					desc: 'action_title_active_power_in_Watts',
				},
			],
		},
		'input.count_change': {
			attrs: [
				{
					name: 'total',
					type: 'number',
					desc: 'action_title_counts_in_units',
				},
				{
					name: 'xtotal',
					type: 'number',
					desc: 'action_title_transformed_counts_value',
				},
			],
		},
		'input.count_measurement': {
			attrs: [
				{
					name: 'total',
					type: 'number',
					desc: 'action_title_counts_in_units',
				},
				{
					name: 'xtotal',
					type: 'number',
					desc: 'action_title_transformed_counts_value',
				},
			],
		},
		'input.freq_change': {
			attrs: [
				{
					name: 'freq',
					type: 'number',
					desc: 'action_title_frequency_in_Hz',
				},
				{
					name: 'xfreq',
					type: 'number',
					desc: 'action_title_transformed_frequency_value',
				},
			],
		},
		'input.freq_measurement': {
			attrs: [
				{
					name: 'freq',
					type: 'number',
					desc: 'action_title_frequency_in_Hz',
				},
				{
					name: 'xfreq',
					type: 'number',
					desc: 'action_title_transformed_frequency_value',
				},
			],
		},
		'rgbcct.on': {},
		'rgbcct.off': {},
		'cb.on': {},
		'cb.off': {},
		'cb.undervoltage': {},
		'cb.overvoltage': {},
		'cb.safety_enable': {},
		'cb.safety_disable': {},
		'flood.alarm': {},
		'flood.alarm_off': {},
		'cury.level_changed': {
			attrs: [
				{
					name: 'slot',
					type: 'string',
					desc: 'The vial slot on which the level change was detected',
				},
				{
					name: 'level',
					type: 'number',
					desc: 'The liquid level of the vial in percents',
				},
			],
		},
		'presencezone.presence': {
			attrs: [
				{
					name: 'state',
					type: 'boolean',
					desc: 'Presence in zone',
				},
			],
		},
		'presencezone.counter': {
			attrs: [
				{
					name: 'num_objects',
					type: 'number',
					desc: 'Number of objects in zone',
				},
			],
		},
		'presencezone.enter': {},
		'presencezone.leave': {},
	}),
};

export const lnmWebhookListSupported = {
	types: Object.freeze({
		'lnm.rx_status': {
			attrs: [
				{
					name: 'device',
					type: 'string',
					desc: 'lnm_sender_device_id',
					defaultDesc: 'Sender device ID',
				},
				{
					name: 'status',
					type: 'object',
					desc: 'lnm_received_status_map',
					defaultDesc: 'Received status map',
				},
			],
		},
		'lnm.rx_event': {
			attrs: [
				{
					name: 'device',
					type: 'string',
					desc: 'lnm_sender_device_id',
					defaultDesc: 'Sender device ID',
				},
				{
					name: 'event_data',
					type: 'object',
					desc: 'lnm_received_event_object',
					defaultDesc: 'Received event object',
				},
			],
		},
	}),
};

export const cameraWebhookListSupported = {
	types: Object.freeze({
		'camera.motion': {},
		'camera.motion_end': {},
		'camerazone.motion': {},
		'camerazone.motion_end': {},
	}),
};

export const virtualWebhookListSupported = {
	types: Object.freeze({
		'boolean.change': {
			attrs: [
				{
					name: 'value',
					type: 'boolean',
					desc: 'action_change_value',
				},
			],
		},
		'enum.change': {
			attrs: [
				{
					name: 'value',
					type: 'string',
					desc: 'action_change_value',
				},
			],
		},
		'number.change': {
			attrs: [
				{
					name: 'value',
					type: 'number',
					desc: 'action_change_value',
				},
			],
		},
		'text.change': {
			attrs: [
				{
					name: 'value',
					type: 'string',
					desc: 'action_change_value',
				},
			],
		},
		'button.single_push': {},
		'button.double_push': {},
		'button.triple_push': {},
		'button.long_push': {},
	}),
};

export const bthomeWebhookListSupported = {
	types: Object.freeze({
		'bthomesensor.value_change': {
			attrs: [
				{
					name: 'value',
					type: 'number',
					desc: 'action_change_value',
				},
			],
		},
		'bthomesensor.state_change': {
			attrs: [
				{
					name: 'value',
					type: 'boolean',
					desc: 'action_state_change',
				},
			],
		},
	}),
};

export const bluTRVWebhookListSupported = {
	types: Object.freeze({
		'blutrv.temperature_change': {
			attrs: [
				{
					name: 'tC',
					type: 'number',
					desc: 'action_title_temperature_in_celsius',
				},
				{
					name: 'tF',
					type: 'number',
					desc: 'action_title_temperature_in_fahrenheit',
				},
			],
		},
		'blutrv.position_change': {
			attrs: [
				{
					name: 'position',
					type: 'number',
					desc: 'prop_valve_percent_opening',
				},
			],
		},
	}),
};

export const bthomeButtonWebhookListSupported = {
	types: Object.freeze({
		'bthomesensor.single_push': {},
		'bthomesensor.double_push': {},
		'bthomesensor.triple_push': {},
		'bthomesensor.long_push': {},
	}),
};

export const newBthomeButtonWebhookListSupported = {
	types: Object.freeze({
		'bthomedevice.single_push': {},
		'bthomedevice.double_push': {},
		'bthomedevice.triple_push': {},
		'bthomedevice.long_push': {},
		'bthomedevice.long_double_push': {},
		'bthomedevice.long_triple_push': {},
		'bthomedevice.rotate_left': {
			attrs: [
				{
					name: 'steps',
					type: 'number',
					desc: 'action_rotation_steps',
				},
			],
		},
		'bthomedevice.rotate_right': {
			attrs: [
				{
					name: 'steps',
					type: 'number',
					desc: 'action_rotation_steps',
				},
			],
		},
	}),
};

export const webhookListPro3EmTotalSupported = {
	types: Object.freeze({
		'em.total_active_power_change': {
			attrs: [
				{
					name: 'total_active_power',
					type: 'number',
					desc: 'action_title_total_active_power_in_Watts',
				},
			],
		},
		'em.total_apparent_power_change': {
			attrs: [
				{
					name: 'total_apparent_power',
					type: 'number',
					desc: 'action_title_total_current_in_VAs',
				},
			],
		},
		'em.total_current_change': {
			attrs: [
				{
					name: 'total_current',
					type: 'number',
					desc: 'action_title_total_current_in_Amps',
				},
			],
		},
	}),
};

export const webhookListActivePowerSupported = {
	types: Object.freeze({
		'switch.active_power_change': {
			attrs: [
				{
					name: 'apower',
					type: 'number',
					desc: 'action_title_active_power_in_Watts',
				},
			],
		},
		'switch.active_power_measurement': {
			attrs: [
				{
					name: 'apower',
					type: 'number',
					desc: 'action_title_active_power_in_Watts',
				},
			],
		},
	}),
};
